import { FunctionComponent, SVGProps } from 'react'

export const IconInbox: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  id,
  ...props
}) => {
  const filter0 = `${id}-filter0`
  const filter1 = `${id}-filter1`
  const paint0 = `${id}-paint0`
  const paint1 = `${id}-paint1`
  return (
    <svg
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter={`url(#${filter0})`}>
        <path
          d="M21.3307 12.0234H16.8659C16.5316 12.0234 16.2193 12.1905 16.0339 12.4687L14.9609 14.0781C14.7755 14.3563 14.4632 14.5234 14.1289 14.5234H11.8659C11.5316 14.5234 11.2193 14.3563 11.0339 14.0781L9.96093 12.4687C9.77546 12.1905 9.46323 12.0234 9.12888 12.0234H4.66406"
          fill={`url(#${paint0})`}
          shapeRendering="crispEdges"
        />
        <path
          d="M21.3307 12.0234H16.8659C16.5316 12.0234 16.2193 12.1905 16.0339 12.4687L14.9609 14.0781C14.7755 14.3563 14.4632 14.5234 14.1289 14.5234H11.8659C11.5316 14.5234 11.2193 14.3563 11.0339 14.0781L9.96093 12.4687C9.77546 12.1905 9.46323 12.0234 9.12888 12.0234H4.66406"
          stroke="#C8F252"
          strokeLinecap="square"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter={`url(#${filter1})`}>
        <path
          d="M7.53906 6.28242L4.67465 12.003C4.66769 12.0169 4.66406 12.0322 4.66406 12.0477V17.0241C4.66406 17.4661 4.83966 17.89 5.15222 18.2026C5.46478 18.5152 5.8887 18.6908 6.33073 18.6908H19.6641C20.1061 18.6908 20.53 18.5152 20.8426 18.2026C21.1551 17.89 21.3307 17.4661 21.3307 17.0241V12.0477C21.3307 12.0322 21.3271 12.0169 21.3201 12.003L18.4557 6.28242C18.3177 6.00474 18.105 5.77106 17.8415 5.60765C17.578 5.44425 17.2741 5.35759 16.9641 5.35742H9.03073C8.72066 5.35759 8.41678 5.44425 8.15327 5.60765C7.88975 5.77106 7.67704 6.00474 7.53906 6.28242Z"
          fill={`url(#${paint1})`}
          shapeRendering="crispEdges"
        />
        <path
          d="M7.53906 6.28242L4.67465 12.003C4.66769 12.0169 4.66406 12.0322 4.66406 12.0477V17.0241C4.66406 17.4661 4.83966 17.89 5.15222 18.2026C5.46478 18.5152 5.8887 18.6908 6.33073 18.6908H19.6641C20.1061 18.6908 20.53 18.5152 20.8426 18.2026C21.1551 17.89 21.3307 17.4661 21.3307 17.0241V12.0477C21.3307 12.0322 21.3271 12.0169 21.3201 12.003L18.4557 6.28242C18.3177 6.00474 18.105 5.77106 17.8415 5.60765C17.578 5.44425 17.2741 5.35759 16.9641 5.35742H9.03073C8.72066 5.35759 8.41678 5.44425 8.15327 5.60765C7.88975 5.77106 7.67704 6.00474 7.53906 6.28242Z"
          stroke="#C8F252"
          strokeLinecap="square"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id={filter0}
          x="0.164062"
          y="7.52344"
          width="25.6641"
          height="11.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.784314 0 0 0 0 0.94902 0 0 0 0 0.321569 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2129_12701"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2129_12701"
            result="shape"
          />
        </filter>
        <filter
          id={filter1}
          x="0.164062"
          y="0.857422"
          width="25.6641"
          height="22.334"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.784314 0 0 0 0 0.94902 0 0 0 0 0.321569 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2129_12701"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2129_12701"
            result="shape"
          />
        </filter>
        <linearGradient
          id={paint0}
          x1="12.9974"
          y1="12.0234"
          x2="12.9974"
          y2="14.5234"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#C8F252" stopOpacity="0" />
          <stop offset="1" stopColor="#C8F252" stopOpacity="0.6" />
        </linearGradient>
        <linearGradient
          id={paint1}
          x1="12.9974"
          y1="5.35742"
          x2="12.9974"
          y2="18.6908"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#C8F252" stopOpacity="0" />
          <stop offset="1" stopColor="#C8F252" stopOpacity="0.6" />
        </linearGradient>
      </defs>
    </svg>
  )
}
